import type {GetListResponse, ParamsOptions} from "@/src/modules/core/types";

import {incidentsApi} from "../api";
import type {IncidentReport} from "../types";

class IncidentsService {
  async getIncidentReports(options: ParamsOptions): Promise<GetListResponse<IncidentReport>> {
    const {data} = await incidentsApi.search(options);
    const raw = data as {data?: IncidentReport[]; incident_reports?: IncidentReport[]};
    const items = Array.isArray(raw.data)
      ? raw.data
      : Array.isArray(raw.incident_reports)
        ? raw.incident_reports
        : (raw.data as unknown as {data?: IncidentReport[]})?.data ?? [];
    const meta = (data as {meta?: {total: number; from?: number; to?: number}}).meta ?? {total: 0};
    return {
      data: items,
      meta: {
        total: meta.total,
        from: meta.from ?? 0,
        to: meta.to ?? 0,
      },
    };
  }

  async getIncidentReport(id: number): Promise<IncidentReport | undefined> {
    const {data} = await incidentsApi.getById(id);
    return data.data;
  }

  async createIncidentReport(payload: Record<string, unknown>): Promise<IncidentReport | undefined> {
    const {data} = await incidentsApi.create(payload);
    return data.data;
  }

  async updateIncidentReport(
    id: number,
    payload: Record<string, unknown>,
  ): Promise<IncidentReport | undefined> {
    const {data} = await incidentsApi.update(id, payload);
    return data.data;
  }

  async deleteIncidentReport(id: number): Promise<void> {
    await incidentsApi.delete(id);
  }

  async getIncidentReportTypes(): Promise<
    {incident_report_type_id: number; type: string}[]
  > {
    const {data} = await incidentsApi.getIncidentReportTypes();
    return data.incident_report_types ?? [];
  }
}

export const incidentsService = new IncidentsService();
